<template>
  <div>
    <BreadcrumbStep />

    <h5 class="my-5 text-center">
      <i class="fa fa-credit-card text-primary mr-2" /> Layanan
    </h5>
        
    <ListLayanan mode="buat-permohonan" />
  </div>
</template>

<style scoped>
</style>

<script>
import ListLayanan from '../../components/global/ListLayanan.vue'
import BreadcrumbStep from './BreadcrumbStep.vue'

export default {
    data() {
        return {

        }
    },
    components: {
        ListLayanan, BreadcrumbStep
    },
    mounted(){
        
    }
}
</script>